<section class="industries">
  <div class="max-width-container">
    <div class="container">
      <span class="text-wrapper">Quotations</span>
      <div class="d-flex align-items-start justify-content-between">
        <h1>Quotation Request</h1>
        <button class="btn btn-primary py-3 px-4 mt-5" *ngIf="quoteProducts$ | async as quoteProducts"
          (click)="action(quoteProducts.length > 0 ? 'scroll' : 'link')">
          {{ quoteProducts.length > 0 ? 'Submit for Quote' : 'Add Products to Quote'}}
        </button>
      </div>
      <p>
        Products In Your Quotes
      </p>
    </div>
  </div>
</section>

<section class="indusbottom" *ngIf="quoteProducts$ | async as quoteProducts">
  <div class="max-width-container">
    <div class="container">
      <div class="category-product-list">
        <div class="category-product">
          <div class="category-product-items">
            <div class="product-card category-card card bg-transparent p-3" *ngFor="let data of quoteProducts">
              <div class="card-img">
                <img src="{{ data.image || 'https://placehold.co/600x400?text=No+image' }}" alt="" width="100%" />
                <div class="badges d-none">
                  <span class="badge bg-aqua-25">New</span>
                </div>
              </div>

              <div class="card-content">
                <a class="btn stretched-link p-0 mb-2 title shadow-none" role="button">{{ data.name }}</a>
                <p class="price">
                  ${{ data.price}}
                </p>
                <div class="cart-category">
                  <a (click)="removeToQuote(data.id)" role="button"
                    class="btn btn-primary w-100 align-items-center gap-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path d="M3.25 5.5H4.75H16.75" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round"
                        stroke-linejoin="round"></path>
                      <path
                        d="M7 5.5V4C7 3.60218 7.15804 3.22064 7.43934 2.93934C7.72064 2.65804 8.10218 2.5 8.5 2.5H11.5C11.8978 2.5 12.2794 2.65804 12.5607 2.93934C12.842 3.22064 13 3.60218 13 4V5.5M15.25 5.5V16C15.25 16.3978 15.092 16.7794 14.8107 17.0607C14.5294 17.342 14.1478 17.5 13.75 17.5H6.25C5.85218 17.5 5.47064 17.342 5.18934 17.0607C4.90804 16.7794 4.75 16.3978 4.75 16V5.5H15.25Z"
                        stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                      </path>
                    </svg>
                    Remove from Quote
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="quoteProducts.length == 0">No Products selected yet…</div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="ourTeam pt-md-0" *ngIf="quoteProducts$ | async as quoteProducts" #companyInfoSection>
  <div class="max-width-container" *ngIf="quoteProducts.length > 0">
    <div class="container">
      <div class="top-heading mb-5">
        <h2><span class="inhh"> Company </span> Information</h2>
      </div>
      <div class="team-slide-content py-5">
        <div class="edit-card border-0 shadow-none">
          <form [formGroup]="quoteForm" (ngSubmit)="submitQuote()">
            <div class="row mb-2">
              <div class="col-12 col-md-6">
                <div class="form-group">
                  <label for="firstName" class="form-label">First Name*</label>
                  <input type="text" class="form-control" id="firstName" placeholder="First Name"
                    formControlName="firstName" />
                  <div *ngIf="
                    quoteForm.get('firstName')?.invalid &&
                    quoteForm.get('firstName')?.touched
                  " class="text-danger fs-6 ps-3 pt-2">
                    First Name is required
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="form-group">
                  <label for="lastName" class="form-label">Last Name*</label>
                  <input type="text" class="form-control" id="lastName" placeholder="Last Name"
                    formControlName="lastName" />
                  <div *ngIf="
                    quoteForm.get('lastName')?.invalid &&
                    quoteForm.get('lastName')?.touched
                  " class="text-danger fs-6 ps-3 pt-2">
                    Last Name is required
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="form-group">
                  <label for="Name" class="form-label">Company*</label>
                  <input type="text" class="form-control" id="Name" placeholder="Company"
                    formControlName="companyName" />
                  <div *ngIf="
                    quoteForm.get('companyName')?.invalid &&
                    quoteForm.get('companyName')?.touched
                  " class="text-danger fs-6 ps-3 pt-2">
                    Company Name is required
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="form-group">
                  <label for="phone" class="form-label">Phone*</label>
                  <input type="number" class="form-control" id="phone" placeholder="Phone" formControlName="phone"
                    appInputMaxLength="15" />
                  <div *ngIf="
                    quoteForm.get('phone')?.invalid &&
                    quoteForm.get('phone')?.touched
                  " class="text-danger fs-6 ps-3 pt-2">
                    Phone is required
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="form-group">
                  <label for="Email" class="form-label">Email*</label>
                  <input type="text" class="form-control" id="Email" placeholder="Email" formControlName="email" />
                  <div *ngIf="
                    quoteForm.get('email')?.invalid &&
                    quoteForm.get('email')?.touched
                  " class="text-danger fs-6 ps-3 pt-2">
                    Email is required
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="form-group">
                  <label for="employe" class="form-label">No of Employees*</label>
                  <input type="number" class="form-control" id="employe" placeholder="No of Employees"
                    formControlName="employees" appInputMaxLength="7" />
                  <div *ngIf="
                    quoteForm.get('employees')?.invalid &&
                    quoteForm.get('employees')?.touched
                  " class="text-danger fs-6 ps-3 pt-2">
                    No of Employee is required
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="form-group">
                  <label for="location" class="form-label">Location</label>
                  <input type="text" class="form-control" id="location" placeholder="Location"
                    formControlName="location" />
                  <div *ngIf="
                    quoteForm.get('location')?.invalid &&
                    quoteForm.get('location')?.touched
                  " class="text-danger fs-6 ps-3 pt-2">
                    Location is required
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="form-group">
                  <label for="requirement" class="form-label">When do you require this order?</label>
                  <select formControlName="requirement" class="form-select">
                    <option value="" disabled selected>Select Requirement</option>
                    <option value="urgently">Urgently</option>
                    <option value="onGoing">On Going</option>
                  </select>
                  <div *ngIf="
                    quoteForm.get('requirement')?.invalid &&
                    quoteForm.get('requirement')?.touched
                  " class="text-danger fs-6 ps-3 pt-2">
                    Requirement is required
                  </div>
                </div>
              </div>
            </div>
            <button class="btn px-5 btn-primary">
              Requesting Quote
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>